(function ($, supportsPassiveOption) {
    $.fn.ciResizeNav = function (configObject) {
        var config = {
            stickyClass: 'sticky',
            hideClass: 'hide',
            minScrollTopForSticky: 240,
            minScrollTopForHide: 600,
            turnOffIf: function() {return false;},
            holdStickyClassIf: function() {return false;},
            holdHideClassIf: function() {return false;}
        };   
        var scrollTop = 0;
        var lastScrollTop = 0;
        var scrolling = false;
        var supportsPassive = supportsPassiveOption();
        
        if (typeof configObject === 'object') {
            $.extend(config, configObject);
        }
        
        var initAnimationFrame = function($nav) {
            if (config.turnOffIf()) return;
            
            if (!scrolling) {
                scrolling = true;
                (!window.requestAnimationFrame)
                    ? setTimout(function() {animateNav($nav);}, 250)
                    : requestAnimationFrame(function() {animateNav($nav);});
            }
        };
        
        function animateNav($nav) {
            scrollTop = $(window).scrollTop();
            
            if (scrollTop === lastScrollTop) {
                lastScrollTop = scrollTop;
                scrolling = false;
                
                return;
            }
            
            if (scrollTop > lastScrollTop) { // downscroll
                checkDownscrollConditions($nav);
            } else { // upscroll
                checkUpscrollConditions($nav);
            }
        
            lastScrollTop = scrollTop;
            scrolling = false;
        }
        
        function checkDownscrollConditions($nav) {
            if (!$nav.hasClass(config.stickyClass) && (config.holdStickyClassIf() || scrollTop >= config.minScrollTopForSticky)) {
                $nav.addClass(config.stickyClass); 
            }
            if (!$nav.hasClass(config.hideClass) && (config.holdHideClassIf() || scrollTop >= config.minScrollTopForHide)) {
                $nav.addClass(config.hideClass);
            }
        }
        
        function checkUpscrollConditions($nav) {
            if (!config.holdStickyClassIf() && (scrollTop < config.minScrollTopForSticky)) {
                $nav.removeClass(config.stickyClass); 
            }
            if (!config.holdHideClassIf()) {
                $nav.removeClass(config.hideClass); 
            }
        }
        
        this.each(function() {
            var $me = $(this);
            
            $(window).on('resize', function() {
                if (config.turnOffIf()) {
                    $me.removeClass(config.stickyClass); 
                    $me.removeClass(config.hideClass); 
                } else {
                    checkDownscrollConditions($me);
                    checkUpscrollConditions($me);
                }              
            });

            window.addEventListener('scroll', function() {
                initAnimationFrame($me);
            }, supportsPassive ? {passive: true} : false);           
            initAnimationFrame($me);        
            
            if (scrollTop === 0) {
                checkDownscrollConditions($me);
                checkUpscrollConditions($me);
            }
        });
    };
})(jQuery, ci_Utils.supportsPassiveOption);